export default __webpack_public_path__ + "static/media/PPI-patio-016.ff2f4875.jpg";